var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tab-mbl" } },
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-dropdown",
                  {
                    class: _vm.readonly ? "not-click" : "",
                    attrs: { no: "1", "split-button": "", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.commandHandle(_vm.command1)
                      },
                      command: function(p) {
                        _vm.command1 = p
                        _vm.commandHandle(_vm.command1)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.command1) + " "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CodeSearching")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CodeSearching")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CopyFromTheLastTime")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyFromTheLastTime")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CopyFromOtherBill")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyFromOtherBill")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: { command: _vm.$t("SeaExport.CopyFromHbl") }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CopyFromHbl")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "2",
                      disabled: _vm.feedBtnDisabled,
                      type: "primary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.pm.completefeedClickHandler()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.CompleteTheDetails")) + " ")]
                ),
                _c(
                  "el-dropdown",
                  {
                    class: _vm.btnBLConfirmDisabled ? "not-click" : "",
                    staticStyle: { "padding-left": "5px" },
                    attrs: { no: "3", "split-button": "", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.commandHandle(_vm.command2)
                      },
                      command: function(p) {
                        _vm.command2 = p
                        _vm.commandHandle(_vm.command2)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.command2) + " "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.InviteToChecktheBL")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.InviteToChecktheBL")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_M/HBL_confirmBL"],
                                expression: "['button_M/HBL_confirmBL']"
                              }
                            ],
                            attrs: {
                              command: _vm.$t("SeaExport.ConfirmChecking")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ConfirmChecking")) + " "
                            )
                          ]
                        ),
                        _vm.$checkPermission(["button_M/HBL_identification"])
                          ? _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: _vm.$t(
                                    "SeaExport.IdentificationList"
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.IdentificationList")
                                  ) + " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.CheckingHistory")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CheckingHistory")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t("SeaExport.ReceiptHistory")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ReceiptHistory")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: {
                              command: _vm.$t(
                                "SeaExport.BillingOfLadingRecordManager"
                              )
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.BillingOfLadingRecordManager")
                              ) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.viewSource === "SeBooking"
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_insurance_toInsure"],
                            expression: "['button_insurance_toInsure']"
                          }
                        ],
                        attrs: {
                          no: "4",
                          disabled: _vm.isEdit,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.toInsure()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "el-menu",
                  {
                    staticClass:
                      "el-menu-button el-button el-button--primary el-button--mini",
                    style: {
                      width: _vm.$selectByLang(
                        "80px",
                        "80px",
                        "80px",
                        "120px",
                        "120px",
                        "120px"
                      ),
                      padding: "0",
                      verticalAlign: "top"
                    },
                    attrs: {
                      disabled: !(_vm.action === "look" && _vm.form.uuid),
                      "text-color": "#404144",
                      "active-text-color": "#404144",
                      mode: "horizontal"
                    },
                    on: { select: _vm.toBlPre }
                  },
                  [
                    _c(
                      "el-submenu",
                      {
                        attrs: {
                          index: "index",
                          disabled: !(_vm.action === "look" && _vm.form.uuid)
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "el-menu-btn-text",
                            attrs: { slot: "title" },
                            slot: "title"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.EDIDoc")))]
                        ),
                        _c(
                          "el-submenu",
                          { attrs: { index: "original" } },
                          [
                            _c("template", { slot: "title" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Original")))
                            ]),
                            _c(
                              "el-menu-item",
                              {
                                attrs: {
                                  index: "API0",
                                  disabled: !_vm.billEDIApiOpen
                                }
                              },
                              [_vm._v("API")]
                            ),
                            _c("el-menu-item", { attrs: { index: "FTP1" } }, [
                              _vm._v("FTP")
                            ])
                          ],
                          2
                        ),
                        _c(
                          "el-submenu",
                          { attrs: { index: "correct" } },
                          [
                            _c("template", { slot: "title" }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Correct")))
                            ]),
                            _c("el-menu-item", { attrs: { index: "FTP0" } }, [
                              _vm._v("FTP")
                            ]),
                            _c(
                              "el-menu-item",
                              {
                                attrs: {
                                  index: "API1",
                                  disabled: !_vm.billEDIApiOpen
                                }
                              },
                              [_vm._v("API")]
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                !_vm.job.masterFlag ||
                _vm.job.containerLoadType === _vm.LCL_CARGO_TYPE.code
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          no: "EdiEuBolInfo",
                          disabled: !(_vm.action === "look" && _vm.form.uuid),
                          type: "primary"
                        },
                        on: { click: _vm.ediEuBolInfoHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.EdiEuBolInfo")))]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.btnMergeHblDataVisible,
                        expression: "btnMergeHblDataVisible"
                      }
                    ],
                    attrs: { no: "5", disabled: _vm.readonly, type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.pm.mergeHblData()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.mergeHblData")) + " ")]
                ),
                _c(
                  "el-menu",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.job.signHBL,
                        expression: "!job.signHBL"
                      },
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_EDI_overseasAgentForecast"],
                        expression: "['button_EDI_overseasAgentForecast']"
                      }
                    ],
                    staticClass:
                      "el-menu-button el-button el-button--primary el-button--mini",
                    class: _vm.isEdit ? "is-disabled not-click" : "",
                    staticStyle: { width: "100px", "vertical-align": "top" },
                    attrs: {
                      "text-color": "#404144",
                      "active-text-color": "#404144",
                      mode: "horizontal"
                    },
                    on: { select: _vm.toOverseaAgeFore }
                  },
                  [
                    _c(
                      "el-submenu",
                      { attrs: { index: "index" } },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "el-menu-btn-text",
                            attrs: { slot: "title" },
                            slot: "title"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.OverseasAgeFore")))]
                        ),
                        _c(
                          "el-menu-item",
                          { attrs: { index: _vm.$t("SeaExport.Original") } },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Original")))]
                        ),
                        _c(
                          "el-menu-item",
                          { attrs: { index: _vm.$t("SeaExport.Correct") } },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Correct")))]
                        ),
                        _c(
                          "el-menu-item",
                          {
                            attrs: { index: _vm.$t("SeaExport.deleteSingle") }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.deleteSingle")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "10px" },
                    attrs: {
                      no: "6",
                      value: _vm.form.state >= 2,
                      disabled: true
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Printed")) + " ")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: {
                      no: "7",
                      value: _vm.form.state === 3,
                      disabled: true
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Locked")) + " ")]
                ),
                _c(
                  "el-checkbox",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.enableShipperConsignNotify,
                        expression: "enableShipperConsignNotify"
                      }
                    ],
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "shipperLock", disabled: true },
                    model: {
                      value: _vm.job.shipperLock,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "shipperLock", $$v)
                      },
                      expression: "job.shipperLock"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.ShipperLocked")) + " ")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "8", disabled: _vm.readonly },
                    model: {
                      value: _vm.form.oversea,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "oversea", $$v)
                      },
                      expression: "form.oversea"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.BlBeReleased")) + " ")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "9", disabled: _vm.readonly },
                    model: {
                      value: _vm.form.edi,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "edi", $$v)
                      },
                      expression: "form.edi"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.BlEdi")) + " ")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "10", disabled: _vm.readonly },
                    model: {
                      value: _vm.form.manifestEDI,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "manifestEDI", $$v)
                      },
                      expression: "form.manifestEDI"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.ManifestEdi")) + " ")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "11", disabled: _vm.readonly },
                    model: {
                      value: _vm.form.printParam1,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "printParam1", $$v)
                      },
                      expression: "form.printParam1"
                    }
                  },
                  [_vm._v("Part of ")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "12", disabled: _vm.readonly },
                    model: {
                      value: _vm.form.printParam3,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "printParam3", $$v)
                      },
                      expression: "form.printParam3"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS"
                        )
                      ) + " "
                    )
                  ]
                ),
                _c(
                  "el-checkbox",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.job.barge,
                        expression: "job.barge"
                      }
                    ],
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "13", disabled: _vm.readonly },
                    on: {
                      change: function($event) {
                        return _vm.pm.printParam6Change()
                      }
                    },
                    model: {
                      value: _vm.form.printParam6,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "printParam6", $$v)
                      },
                      expression: "form.printParam6"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("SeaExport.PrintBargeVesselAndVoyage")) +
                        " "
                    )
                  ]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "14", disabled: _vm.readonly },
                    model: {
                      value: _vm.form.showPODAgency,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showPODAgency", $$v)
                      },
                      expression: "form.showPODAgency"
                    }
                  },
                  [_vm._v("ShowPODAgency ")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.btnExcelVisible,
                        expression: "btnExcelVisible"
                      }
                    ],
                    staticStyle: { "margin-right": "10px" },
                    attrs: { no: "15", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.pm.exportToExcel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.ExportToExcel")) + " ")]
                )
              ],
              1
            )
          ]
        )
      ]),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c(
          "div",
          { staticClass: "section form-column" },
          [
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.form.showDetail,
                    expression: "!form.showDetail"
                  }
                ],
                staticStyle: { height: "100%" },
                attrs: { "label-width": "70px", "label-position": "right" }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "white-space": "nowrap",
                      "min-width": "100%",
                      "margin-bottom": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        staticStyle: { "flex-shrink": "0" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")
                          )
                        )
                      ]
                    ),
                    _c("div", { staticStyle: { "flex-grow": "1" } }),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "flex-shrink": "0" },
                        attrs: {
                          no: "formatChange",
                          disabled: _vm.readonly,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.formatChange(true)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_DetailFormat")) + " "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    class: _vm.variableCss.shipperCode
                  },
                  [
                    _c(
                      "span",
                      {
                        class: _vm.variableCss.shipperLine,
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex", width: "100%" } },
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          ref: "shipperCode",
                          class: _vm.importDifferenceField.shipperCode
                            ? "red-border"
                            : "",
                          staticStyle: { flex: "1" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              (!_vm.readonly && _vm.job.shipperLock),
                            no: "16"
                          },
                          model: {
                            value: _vm.form.shipperCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipperCode", $$v)
                            },
                            expression: "form.shipperCode"
                          }
                        }),
                        _c("cargo-advance-select", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          class: _vm.importDifferenceField.shipperId
                            ? "red-border"
                            : "",
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "17",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { shipper: true, active: true },
                            filterable: "",
                            "default-value": _vm.form.shipperId || "",
                            disabled:
                              _vm.readonly ||
                              (!_vm.readonly && _vm.job.shipperLock)
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.shipperAutoCompleteChange(p)
                            }
                          }
                        }),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: {
                              no: "18",
                              type: "primary",
                              disabled:
                                _vm.readonly ||
                                (!_vm.readonly && _vm.job.shipperLock)
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.onClear(1)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                        ),
                        _c("char-count", {
                          attrs: {
                            inline: "",
                            form: _vm.form,
                            prefix: "shipper"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._l(7, function(count) {
                  return _c(
                    "el-form-item",
                    {
                      key: "shipperLine" + count,
                      staticClass: "auto-width",
                      class: _vm.getClass("shipperLine", count)
                    },
                    [
                      _c(
                        "special-character-tip",
                        {
                          attrs: {
                            texts: _vm.specialCharCheck["shipperLine" + count]
                          }
                        },
                        [
                          _c("cargo-input", {
                            ref: "shipperLine" + count,
                            refInFor: true,
                            class: _vm.importDifferenceField[
                              "shipperLine" + count
                            ]
                              ? "red-border"
                              : "",
                            attrs: {
                              no: "shipperLine" + count,
                              placeholder: _vm.placeholderSFT(count),
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              disabled:
                                _vm.readonly ||
                                (!_vm.readonly && _vm.job.shipperLock),
                              "filter-chars": false,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "shipperLine" + count,
                                  count + 1 > 6
                                    ? null
                                    : "shipperLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showShipperDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form["shipperLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "shipperLine" + count, $$v)
                              },
                              expression: "form['shipperLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    class: _vm.variableCss.consigneeCode
                  },
                  [
                    _c(
                      "span",
                      {
                        class: _vm.variableCss.consigneeLine,
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex", width: "100%" } },
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          ref: "consigneeCode",
                          class: _vm.importDifferenceField.consigneeCode
                            ? "red-border"
                            : "",
                          staticStyle: { flex: "1" },
                          attrs: { disabled: _vm.readonly, no: "19" },
                          model: {
                            value: _vm.form.consigneeCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consigneeCode", $$v)
                            },
                            expression: "form.consigneeCode"
                          }
                        }),
                        _c("cargo-advance-select", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          class: _vm.importDifferenceField.consigneeId
                            ? "red-border"
                            : "",
                          staticStyle: { flex: "1" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "20",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { consignee: true, active: true },
                            filterable: "",
                            "default-value": _vm.form.consigneeId || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.consigneeAutoCompleteChange(p)
                            }
                          }
                        }),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: {
                              no: "21",
                              type: "primary",
                              disabled: _vm.readonly
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.onClear(2)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                        ),
                        _c("char-count", {
                          attrs: {
                            inline: "",
                            form: _vm.form,
                            prefix: "consignee"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._l(7, function(count) {
                  return _c(
                    "el-form-item",
                    {
                      key: "consigneeLine" + count,
                      staticClass: "auto-width",
                      class: _vm.getClass("consigneeLine", count)
                    },
                    [
                      _c(
                        "special-character-tip",
                        {
                          attrs: {
                            texts: _vm.specialCharCheck["consigneeLine" + count]
                          }
                        },
                        [
                          _c("cargo-input", {
                            ref: "consigneeLine" + count,
                            refInFor: true,
                            class: _vm.importDifferenceField[
                              "consigneeLine" + count
                            ]
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              no: "consigneeLine" + count,
                              placeholder: _vm.placeholderSFT(count),
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "filter-chars": false,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "consigneeLine" + count,
                                  count + 1 > 6
                                    ? null
                                    : "consigneeLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showConsigneeDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form["consigneeLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "consigneeLine" + count, $$v)
                              },
                              expression: "form['consigneeLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    class: _vm.variableCss.notifyCode
                  },
                  [
                    _c(
                      "span",
                      {
                        class: _vm.variableCss.notifyLine,
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.NotifyParty")))]
                    ),
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          ref: "notifyCode",
                          class: _vm.importDifferenceField.notifyCode
                            ? "red-border"
                            : "",
                          attrs: { disabled: _vm.readonly, no: "22" },
                          model: {
                            value: _vm.form.notifyCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notifyCode", $$v)
                            },
                            expression: "form.notifyCode"
                          }
                        }),
                        _c("cargo-advance-select", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          class: _vm.importDifferenceField.notifyId
                            ? "red-border"
                            : "",
                          attrs: {
                            disabled: _vm.readonly,
                            no: "23",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { notify: true, active: true },
                            filterable: "",
                            "default-value": _vm.form.notifyId || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.notifyAutoCompleteChange(p)
                            }
                          }
                        }),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "5px" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "24",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onClear(3)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "25",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onCopyConsignee()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyTheConsignee")) +
                                    " "
                                )
                              ]
                            ),
                            _c("char-count", {
                              attrs: {
                                inline: "",
                                form: _vm.form,
                                prefix: "notify"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._l(7, function(count) {
                  return _c(
                    "el-form-item",
                    {
                      key: "notifyLine" + count,
                      staticClass: "auto-width",
                      class: _vm.getClass("notifyLine", count)
                    },
                    [
                      _c(
                        "special-character-tip",
                        {
                          attrs: {
                            texts: _vm.specialCharCheck["notifyLine" + count]
                          }
                        },
                        [
                          _c("cargo-input", {
                            ref: "notifyLine" + count,
                            refInFor: true,
                            class: _vm.importDifferenceField[
                              "consigneeLine" + count
                            ]
                              ? "red-border"
                              : "",
                            attrs: {
                              disabled: _vm.readonly,
                              no: "notifyLine" + count,
                              placeholder: _vm.placeholderSFT(count),
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify,
                              "filter-chars": false,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "notifyLine" + count,
                                  count + 1 > 6
                                    ? null
                                    : "notifyLine" + (count + 1),
                                  _vm.maxChars
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showNotifyDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form["notifyLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "notifyLine" + count, $$v)
                              },
                              expression: "form['notifyLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { flex: "1" },
                          attrs: { disabled: _vm.readonly, no: "26" },
                          on: {
                            change: function(val) {
                              _vm.pm.otherInfoChangeHandler(val)
                            }
                          },
                          model: {
                            value: _vm.otherSelectField,
                            callback: function($$v) {
                              _vm.otherSelectField = $$v
                            },
                            expression: "otherSelectField"
                          }
                        },
                        _vm._l(_vm.otherFieldsData, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.englishName, value: item.code }
                          })
                        }),
                        1
                      ),
                      _vm.otherSelectField !== "ALSO NOTIFY"
                        ? _c("cargo-input", {
                            staticStyle: { flex: "1", "margin-left": "5px" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "27",
                              maxlength: _vm.maxChars,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            model: {
                              value: _vm.otherCode,
                              callback: function($$v) {
                                _vm.otherCode = $$v
                              },
                              expression: "otherCode"
                            }
                          })
                        : _vm._e(),
                      _vm.otherSelectField === "ALSO NOTIFY"
                        ? _c("cargo-advance-select", {
                            staticStyle: { flex: "1", "margin-left": "5px" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "68",
                              "allow-create": true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { notify: true, active: true },
                              "tag-name": "englishName",
                              "tag-value": "englishName",
                              filterable: "",
                              "default-value": _vm.otherCode || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.alsoNotifyAutoCompleteChange(p)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.otherSelectField === "ALSO NOTIFY",
                        expression: "otherSelectField==='ALSO NOTIFY'"
                      }
                    ],
                    staticStyle: { "margin-left": "20px" }
                  },
                  [
                    _c("cargo-rich-textarea", {
                      staticStyle: { height: "110px", "margin-left": "50px" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "28",
                        "text-chars": 0,
                        "wrap-symbol": "r",
                        "auto-half-word": "",
                        "auto-uppercase": _vm.notUppercaseShipperConsigneNotify
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showAdvanceTextDialog(
                            "ALSO NOTIFY",
                            _vm.form.alsoNotify,
                            function(val) {
                              _vm.form.alsoNotify = val
                            },
                            false,
                            null,
                            _vm.notUppercaseShipperConsigneNotify,
                            {
                              warningCount: 45,
                              maxChar: 0,
                              autoUppercase:
                                _vm.notUppercaseShipperConsigneNotify,
                              autoHalfWord: true
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.form.alsoNotify,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "alsoNotify", $$v)
                        },
                        expression: "form.alsoNotify"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.otherSelectField === "DGCONSIGN",
                        expression: "otherSelectField==='DGCONSIGN'"
                      }
                    ],
                    staticStyle: { "margin-left": "20px" }
                  },
                  _vm._l(7, function(count) {
                    return _c(
                      "el-form-item",
                      {
                        key: "dgconsignLine" + count,
                        staticClass: "auto-width"
                      },
                      [
                        _c("cargo-input", {
                          ref: "dgconsignLine" + count,
                          refInFor: true,
                          attrs: {
                            disabled: _vm.readonly,
                            no: "29",
                            "auto-uppercase": _vm.isUppercase,
                            "use-read-only": true
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.form,
                                "dgconsignLine" + count,
                                count + 1 > 6
                                  ? null
                                  : "dgconsignLine" + (count + 1),
                                _vm.maxChars
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showDgconsignDialog($event)
                            }
                          },
                          model: {
                            value: _vm.form["dgconsignLine" + count],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dgconsignLine" + count, $$v)
                            },
                            expression: "form['dgconsignLine'+count]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.otherSelectField === "ELSEINVOICE",
                        expression: "otherSelectField==='ELSEINVOICE'"
                      }
                    ],
                    staticStyle: { "margin-left": "20px" }
                  },
                  _vm._l(7, function(count) {
                    return _c(
                      "el-form-item",
                      {
                        key: "elseInvoiceLine" + count,
                        staticClass: "auto-width"
                      },
                      [
                        _c("cargo-input", {
                          ref: "elseInvoiceLine" + count,
                          refInFor: true,
                          attrs: {
                            disabled: _vm.readonly,
                            no: "30",
                            "auto-uppercase": _vm.isUppercase,
                            "use-read-only": true
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.form,
                                "elseInvoiceLine" + count,
                                count + 1 > 6
                                  ? null
                                  : "elseInvoiceLine" + (count + 1),
                                _vm.maxChars
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showElseInvoiceDialog($event)
                            }
                          },
                          model: {
                            value: _vm.form["elseInvoiceLine" + count],
                            callback: function($$v) {
                              _vm.$set(_vm.form, "elseInvoiceLine" + count, $$v)
                            },
                            expression: "form['elseInvoiceLine'+count]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  1
                ),
                _vm.job.paymentTermMBL === "3P"
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        staticStyle: { "padding-top": "5px" }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Payment1")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex", width: "100%" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "paymentCode"
                              },
                              model: {
                                value: _vm.form.paymentCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "paymentCode", $$v)
                                },
                                expression: "form.paymentCode"
                              }
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "BringInData",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.paymentImportData(true)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_BringInData")) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._l(7, function(count) {
                  return _vm.job.paymentTermMBL === "3P"
                    ? _c(
                        "el-form-item",
                        {
                          key: "paymentLine" + count,
                          staticClass: "auto-width"
                        },
                        [
                          _c("cargo-input", {
                            ref: "paymentLine" + count,
                            refInFor: true,
                            attrs: {
                              disabled: _vm.readonly,
                              no: "paymentLine" + count,
                              placeholder: _vm.placeholderSFT(count),
                              "auto-uppercase": _vm.isUppercase,
                              "filter-chars": false,
                              "use-read-only": true
                            },
                            on: {
                              change: function() {
                                return _vm.wrapAddr(
                                  _vm.form,
                                  "paymentLine" + count,
                                  count + 1 > 6
                                    ? null
                                    : "paymentLine" + (count + 1),
                                  0
                                )
                              }
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                return _vm.showPaymentDialog($event)
                              }
                            },
                            model: {
                              value: _vm.form["paymentLine" + count],
                              callback: function($$v) {
                                _vm.$set(_vm.form, "paymentLine" + count, $$v)
                              },
                              expression: "form['paymentLine'+count]"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                })
              ],
              2
            ),
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.showDetail,
                    expression: "form.showDetail"
                  }
                ],
                staticStyle: { height: "100%" },
                attrs: { "label-width": "70px", "label-position": "right" }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "white-space": "nowrap",
                      "min-width": "100%",
                      "margin-bottom": "10px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        staticStyle: { "flex-shrink": "0" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")
                          )
                        )
                      ]
                    ),
                    _c("div", { staticStyle: { "flex-grow": "1" } }),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "flex-shrink": "0" },
                        attrs: {
                          no: "GeneralFormat",
                          disabled: _vm.readonly,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.formatChange(false)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_GeneralFormat")) + " "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    class: _vm.variableCss.shipperCode
                  },
                  [
                    _c(
                      "span",
                      {
                        class: _vm.variableCss.shipperLine,
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Shipper")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex", width: "100%" } },
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          ref: "shipperCode",
                          staticStyle: { flex: "1" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              (!_vm.readonly && _vm.job.shipperLock),
                            no: "16"
                          },
                          model: {
                            value: _vm.form.shipperCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipperCode", $$v)
                            },
                            expression: "form.shipperCode"
                          }
                        }),
                        _c("cargo-advance-select", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "17",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { shipper: true, active: true },
                            filterable: "",
                            "default-value": _vm.form.shipperId || "",
                            disabled:
                              _vm.readonly ||
                              (!_vm.readonly && _vm.job.shipperLock)
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.shipperAutoCompleteChange(p, true)
                            }
                          }
                        }),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: {
                              no: "18",
                              type: "primary",
                              disabled:
                                _vm.readonly ||
                                (!_vm.readonly && _vm.job.shipperLock)
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.onClear(1, true)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "shipperLine1",
                        "filter-chars": false,
                        "use-read-only": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "shipperLine1",
                            "shipperLine2",
                            _vm.maxChars
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showShipperDialog($event)
                        }
                      },
                      model: {
                        value: _vm.form.shipperLine1,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shipperLine1", $$v)
                        },
                        expression: "form.shipperLine1"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "shipperLine2",
                        "filter-chars": false,
                        "use-read-only": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "shipperLine2",
                            "shipperLine3",
                            _vm.maxChars
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showShipperDialog($event)
                        }
                      },
                      model: {
                        value: _vm.form.shipperLine2,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shipperLine2", $$v)
                        },
                        expression: "form.shipperLine2"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "shipperLine3",
                        "filter-chars": false,
                        "use-read-only": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "shipperLine3",
                            "shipperLine4",
                            _vm.maxChars
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showShipperDialog($event)
                        }
                      },
                      model: {
                        value: _vm.form.shipperLine3,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shipperLine3", $$v)
                        },
                        expression: "form.shipperLine3"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "-10px" },
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "shipperCountry",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.shipperCountry,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipperCountry", $$v)
                            },
                            expression: "form.shipperCountry"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_CityP") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "shipperCity",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.shipperCity,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperCity", $$v)
                                },
                                expression: "form.shipperCity"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "shipperProvince",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.shipperProvince,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipperProvince", $$v)
                            },
                            expression: "form.shipperProvince"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PostalCode")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "shipperZipCode",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.shipperZipCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperZipCode", $$v)
                                },
                                expression: "form.shipperZipCode"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "shipperMobile",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.shipperMobile,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipperMobile", $$v)
                            },
                            expression: "form.shipperMobile"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_email") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "shipperEmail",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.shipperEmail,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperEmail", $$v)
                                },
                                expression: "form.shipperEmail"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "padding-bottom": "5px"
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "shipperContact",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.shipperContact,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipperContact", $$v)
                            },
                            expression: "form.shipperContact"
                          }
                        }),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Fax" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "shipperFax",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.shipperFax,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperFax", $$v)
                                },
                                expression: "form.shipperFax"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    class: _vm.variableCss.consigneeCode
                  },
                  [
                    _c(
                      "span",
                      {
                        class: _vm.variableCss.consigneeLine,
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Consignee")))]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex", width: "100%" } },
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          ref: "consigneeCode",
                          staticStyle: { flex: "1" },
                          attrs: { disabled: _vm.readonly, no: "19" },
                          model: {
                            value: _vm.form.consigneeCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consigneeCode", $$v)
                            },
                            expression: "form.consigneeCode"
                          }
                        }),
                        _c("cargo-advance-select", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          staticStyle: { flex: "1" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "20",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { consignee: true, active: true },
                            filterable: "",
                            "default-value": _vm.form.consigneeId || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.consigneeAutoCompleteChange(p, true)
                            }
                          }
                        }),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "5px" },
                            attrs: {
                              no: "21",
                              type: "primary",
                              disabled: _vm.readonly
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.onClear(2, true)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "consigneeLine1",
                        "filter-chars": false,
                        "use-read-only": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "consigneeLine1",
                            "consigneeLine2",
                            _vm.maxChars
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showConsigneeDialog($event)
                        }
                      },
                      model: {
                        value: _vm.form.consigneeLine1,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "consigneeLine1", $$v)
                        },
                        expression: "form.consigneeLine1"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "consigneeLine2",
                        "filter-chars": false,
                        "use-read-only": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "consigneeLine2",
                            "consigneeLine3",
                            _vm.maxChars
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showConsigneeDialog($event)
                        }
                      },
                      model: {
                        value: _vm.form.consigneeLine2,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "consigneeLine2", $$v)
                        },
                        expression: "form.consigneeLine2"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "consigneeLine3",
                        "filter-chars": false,
                        "use-read-only": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "consigneeLine3",
                            "consigneeLine4",
                            _vm.maxChars
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showConsigneeDialog($event)
                        }
                      },
                      model: {
                        value: _vm.form.consigneeLine3,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "consigneeLine3", $$v)
                        },
                        expression: "form.consigneeLine3"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "consigneeCountry",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.consigneeCountry,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consigneeCountry", $$v)
                            },
                            expression: "form.consigneeCountry"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_CityP") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "consigneeCity",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.consigneeCity,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeCity", $$v)
                                },
                                expression: "form.consigneeCity"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "consigneeProvince",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.consigneeProvince,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consigneeProvince", $$v)
                            },
                            expression: "form.consigneeProvince"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PostalCode")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "consigneeZipCode",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.consigneeZipCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeZipCode", $$v)
                                },
                                expression: "form.consigneeZipCode"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "consigneeMobile",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.consigneeMobile,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consigneeMobile", $$v)
                            },
                            expression: "form.consigneeMobile"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_email") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "consigneeEmail",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.consigneeEmail,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeEmail", $$v)
                                },
                                expression: "form.consigneeEmail"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "padding-bottom": "5px"
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "consigneeContact",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.consigneeContact,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "consigneeContact", $$v)
                            },
                            expression: "form.consigneeContact"
                          }
                        }),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Fax" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "consigneeFax",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.consigneeFax,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeFax", $$v)
                                },
                                expression: "form.consigneeFax"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    class: _vm.variableCss.notifyCode
                  },
                  [
                    _c(
                      "span",
                      {
                        class: _vm.variableCss.notifyLine,
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.NotifyParty")))]
                    ),
                    _c(
                      "div",
                      [
                        _c("el-input", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          ref: "notifyCode",
                          attrs: { disabled: _vm.readonly, no: "22" },
                          model: {
                            value: _vm.form.notifyCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notifyCode", $$v)
                            },
                            expression: "form.notifyCode"
                          }
                        }),
                        _c("cargo-advance-select", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                              expression:
                                "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                            }
                          ],
                          attrs: {
                            disabled: _vm.readonly,
                            no: "23",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { notify: true, active: true },
                            filterable: "",
                            "default-value": _vm.form.notifyId || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.notifyAutoCompleteChange(p, true)
                            }
                          }
                        }),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "5px" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "24",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onClear(3, true)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")) + " ")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  no: "25",
                                  type: "primary",
                                  disabled: _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.pm.onCopyConsignee(true)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CopyTheConsignee")) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        no: "notifyLine2",
                        disabled: _vm.readonly,
                        "filter-chars": false,
                        "use-read-only": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "notifyLine1",
                            "notifyLine2",
                            _vm.maxChars
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showNotifyDialog($event)
                        }
                      },
                      model: {
                        value: _vm.form.notifyLine1,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "notifyLine1", $$v)
                        },
                        expression: "form.notifyLine1"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        no: "notifyLine2",
                        disabled: _vm.readonly,
                        "filter-chars": false,
                        "use-read-only": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "notifyLine2",
                            "notifyLine3",
                            _vm.maxChars
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showNotifyDialog($event)
                        }
                      },
                      model: {
                        value: _vm.form.notifyLine2,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "notifyLine2", $$v)
                        },
                        expression: "form.notifyLine2"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        no: "notifyLine3",
                        disabled: _vm.readonly,
                        "filter-chars": false,
                        "use-read-only": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.form,
                            "notifyLine3",
                            "notifyLine4",
                            _vm.maxChars
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showNotifyDialog($event)
                        }
                      },
                      model: {
                        value: _vm.form.notifyLine3,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "notifyLine3", $$v)
                        },
                        expression: "form.notifyLine3"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "notifyCountry",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.notifyCountry,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notifyCountry", $$v)
                            },
                            expression: "form.notifyCountry"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_CityP") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "notifyCity",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.notifyCity,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyCity", $$v)
                                },
                                expression: "form.notifyCity"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "notifyProvince",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.notifyProvince,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notifyProvince", $$v)
                            },
                            expression: "form.notifyProvince"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PostalCode")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "notifyZipCode",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.notifyZipCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyZipCode", $$v)
                                },
                                expression: "form.notifyZipCode"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: { no: "notifyMobile", disabled: _vm.readonly },
                          model: {
                            value: _vm.form.notifyMobile,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notifyMobile", $$v)
                            },
                            expression: "form.notifyMobile"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_email") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "notifyEmail",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.notifyEmail,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyEmail", $$v)
                                },
                                expression: "form.notifyEmail"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "padding-bottom": "5px"
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "notifyContact",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.notifyContact,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "notifyContact", $$v)
                            },
                            expression: "form.notifyContact"
                          }
                        }),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Fax" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "notifyFax",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.notifyFax,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyFax", $$v)
                                },
                                expression: "form.notifyFax"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "otherSelectField",
                            disabled: _vm.readonly
                          },
                          on: {
                            change: function(val) {
                              _vm.pm.otherInfoChangeHandler(val)
                            }
                          },
                          model: {
                            value: _vm.otherSelectField,
                            callback: function($$v) {
                              _vm.otherSelectField = $$v
                            },
                            expression: "otherSelectField"
                          }
                        },
                        _vm._l(_vm.otherFieldsData, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.englishName, value: item.code }
                          })
                        }),
                        1
                      ),
                      _vm.otherSelectField !== "ALSO NOTIFY"
                        ? _c("cargo-input", {
                            staticStyle: { flex: "1", "margin-left": "5px" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "maxChars",
                              maxlength: _vm.maxChars,
                              "auto-uppercase":
                                _vm.notUppercaseShipperConsigneNotify
                            },
                            model: {
                              value: _vm.otherCode,
                              callback: function($$v) {
                                _vm.otherCode = $$v
                              },
                              expression: "otherCode"
                            }
                          })
                        : _vm._e(),
                      _vm.otherSelectField === "ALSO NOTIFY"
                        ? _c("cargo-advance-select", {
                            staticStyle: { flex: "1", "margin-left": "5px" },
                            attrs: {
                              disabled: _vm.readonly,
                              no: "otherCode",
                              "allow-create": true,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { notify: true, active: true },
                              "tag-name": "englishName",
                              "tag-value": "englishName",
                              filterable: "",
                              "default-value": _vm.otherCode || ""
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.alsoNotifyAutoCompleteChange(p)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        no: "alsoNotifyLine1",
                        disabled: _vm.readonly,
                        "filter-chars": false,
                        "use-read-only": true,
                        "auto-uppercase": true
                      },
                      on: { change: _vm.alsoChange },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            "ALSO NOTIFY",
                            _vm.form.alsoNotify,
                            function(val) {
                              _vm.summarizeAlso(val)
                            },
                            false,
                            null,
                            true,
                            {
                              warningCount: 45,
                              maxChar: 0,
                              autoUppercase: true,
                              autoHalfWord: true
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.alsoNotify.line1,
                        callback: function($$v) {
                          _vm.$set(_vm.alsoNotify, "line1", $$v)
                        },
                        expression: "alsoNotify.line1"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        no: "alsoNotifyLine2",
                        disabled: _vm.readonly,
                        "filter-chars": false,
                        "use-read-only": true,
                        "auto-uppercase": true
                      },
                      on: { change: _vm.alsoChange },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            "ALSO NOTIFY",
                            _vm.form.alsoNotify,
                            function(val) {
                              _vm.summarizeAlso(val)
                            },
                            false,
                            null,
                            true,
                            {
                              warningCount: 45,
                              maxChar: 0,
                              autoUppercase: true,
                              autoHalfWord: true
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.alsoNotify.line2,
                        callback: function($$v) {
                          _vm.$set(_vm.alsoNotify, "line2", $$v)
                        },
                        expression: "alsoNotify.line2"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                  },
                  [
                    _c("cargo-input", {
                      attrs: {
                        no: "alsoNotifyLine3",
                        disabled: _vm.readonly,
                        "filter-chars": false,
                        "use-read-only": true,
                        "auto-uppercase": true
                      },
                      on: { change: _vm.alsoChange },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            "ALSO NOTIFY",
                            _vm.form.alsoNotify,
                            function(val) {
                              _vm.summarizeAlso(val)
                            },
                            false,
                            null,
                            true,
                            {
                              warningCount: 45,
                              maxChar: 0,
                              autoUppercase: true,
                              autoHalfWord: true
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.alsoNotify.line3,
                        callback: function($$v) {
                          _vm.$set(_vm.alsoNotify, "line3", $$v)
                        },
                        expression: "alsoNotify.line3"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "alsoNotifyCountry",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.alsoNotifyCountry,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "alsoNotifyCountry", $$v)
                            },
                            expression: "form.alsoNotifyCountry"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_CityP") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "alsoNotifyCity",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.alsoNotifyCity,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "alsoNotifyCity", $$v)
                                },
                                expression: "form.alsoNotifyCity"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "alsoNotifyProvince",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.alsoNotifyProvince,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "alsoNotifyProvince", $$v)
                            },
                            expression: "form.alsoNotifyProvince"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_PostalCode")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "alsoNotifyZipCode",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.alsoNotifyZipCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "alsoNotifyZipCode", $$v)
                                },
                                expression: "form.alsoNotifyZipCode"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "alsoNotifyMobile",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.alsoNotifyMobile,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "alsoNotifyMobile", $$v)
                            },
                            expression: "form.alsoNotifyMobile"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_email") }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "alsoNotifyEmail",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.alsoNotifyEmail,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "alsoNotifyEmail", $$v)
                                },
                                expression: "form.alsoNotifyEmail"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "padding-bottom": "5px"
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "80px" },
                          attrs: {
                            no: "alsoNotifyContact",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.alsoNotifyContact,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "alsoNotifyContact", $$v)
                            },
                            expression: "form.alsoNotifyContact"
                          }
                        }),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Fax" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "80px" },
                              attrs: {
                                no: "alsoNotifyFax",
                                disabled: _vm.readonly
                              },
                              model: {
                                value: _vm.form.alsoNotifyFax,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "alsoNotifyFax", $$v)
                                },
                                expression: "form.alsoNotifyFax"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm.job.paymentTermMBL === "3P"
                  ? _c(
                      "div",
                      [
                        _c("el-form-item", { staticClass: "auto-width" }, [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Payment1")))]
                          ),
                          _c(
                            "div",
                            { staticStyle: { display: "flex", width: "100%" } },
                            [
                              _c("el-input", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "paymentCode",
                                  disabled: _vm.readonly
                                },
                                model: {
                                  value: _vm.form.paymentCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "paymentCode", $$v)
                                  },
                                  expression: "form.paymentCode"
                                }
                              }),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    no: "BringInData",
                                    type: "primary",
                                    disabled: _vm.readonly
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.paymentImportData(false)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_BringInData")
                                    ) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "paymentLine1",
                                disabled: _vm.readonly,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "paymentLine1",
                                    "paymentLine2",
                                    0
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showPaymentDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.paymentLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "paymentLine1", $$v)
                                },
                                expression: "form.paymentLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "1" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "paymentLine2",
                                disabled: _vm.readonly,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "paymentLine2",
                                    "paymentLine3",
                                    0
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showPaymentDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.paymentLine2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "paymentLine2", $$v)
                                },
                                expression: "form.paymentLine2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("SeaExport.Addr") + "2" }
                          },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "paymentLine3",
                                disabled: _vm.readonly,
                                "filter-chars": false,
                                "use-read-only": true
                              },
                              on: {
                                change: function() {
                                  return _vm.wrapAddr(
                                    _vm.form,
                                    "paymentLine1",
                                    "paymentLine2",
                                    0
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showPaymentDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.paymentLine3,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "paymentLine3", $$v)
                                },
                                expression: "form.paymentLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Country") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    no: "paymentCountry",
                                    disabled: _vm.readonly
                                  },
                                  model: {
                                    value: _vm.form.paymentCountry,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "paymentCountry", $$v)
                                    },
                                    expression: "form.paymentCountry"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_CityP")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "80px" },
                                      attrs: {
                                        no: "paymentCity",
                                        disabled: _vm.readonly
                                      },
                                      model: {
                                        value: _vm.form.paymentCity,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "paymentCity", $$v)
                                        },
                                        expression: "form.paymentCity"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Province1") }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    no: "paymentProvince",
                                    disabled: _vm.readonly
                                  },
                                  model: {
                                    value: _vm.form.paymentProvince,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "paymentProvince", $$v)
                                    },
                                    expression: "form.paymentProvince"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_PostalCode")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "80px" },
                                      attrs: {
                                        no: "paymentPostalCode",
                                        disabled: _vm.readonly
                                      },
                                      model: {
                                        value: _vm.form.paymentPostalCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "paymentPostalCode",
                                            $$v
                                          )
                                        },
                                        expression: "form.paymentPostalCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Tel") } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    no: "paymentPhone",
                                    disabled: _vm.readonly
                                  },
                                  model: {
                                    value: _vm.form.paymentPhone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "paymentPhone", $$v)
                                    },
                                    expression: "form.paymentPhone"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "auto-width",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_email")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "80px" },
                                      attrs: {
                                        no: "paymentEmail",
                                        disabled: _vm.readonly
                                      },
                                      model: {
                                        value: _vm.form.paymentEmail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "paymentEmail",
                                            $$v
                                          )
                                        },
                                        expression: "form.paymentEmail"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: _vm.$t("CargoMsg.Cargo_Contact") }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "padding-bottom": "5px"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "80px" },
                                  attrs: {
                                    no: "paymentContact",
                                    disabled: _vm.readonly
                                  },
                                  model: {
                                    value: _vm.form.paymentContact,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "paymentContact", $$v)
                                    },
                                    expression: "form.paymentContact"
                                  }
                                }),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "Fax" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "80px" },
                                      attrs: {
                                        no: "paymentFax",
                                        disabled: _vm.readonly
                                      },
                                      model: {
                                        value: _vm.form.paymentFax,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "paymentFax", $$v)
                                        },
                                        expression: "form.paymentFax"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "section form-column",
            staticStyle: { width: "345px" }
          },
          [
            _c(
              "el-form",
              {
                staticStyle: { height: "100%" },
                attrs: {
                  disabled: _vm.readonly,
                  "label-width": "125px",
                  "label-position": "right"
                }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
                ]),
                _c(
                  "el-form-item",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: _vm.synContainerInfoDisable
                        },
                        on: { click: _vm.syncContainerInfoDialogHandle }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.SyncContainerInfoTotal"))
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.quantity,
                    attrs: { label: _vm.$t("SeaExport.NumberOfPackagesOnBl") }
                  },
                  [
                    _c("auto-number-input", {
                      class: _vm.importDifferenceField.quantity
                        ? "red-border"
                        : "",
                      attrs: {
                        no: "31",
                        precision: 0,
                        min: 0,
                        disabled: !_vm.isJydEditJobFields
                      },
                      on: {
                        change: function($event) {
                          return _vm.pm.quantityChange()
                        }
                      },
                      model: {
                        value: _vm.form.quantity,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "quantity", $$v)
                        },
                        expression: "form.quantity"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.packing,
                    attrs: { label: _vm.$t("SeaExport.Package") }
                  },
                  [
                    _c("cargo-packing-select", {
                      class: _vm.importDifferenceField.packing
                        ? "red-border"
                        : "",
                      attrs: { no: "32", "default-value": _vm.form.packing },
                      on: {
                        change: function(p) {
                          _vm.pm.packingChange(p)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.PackageDisplayName") } },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.packingName
                        ? "red-border"
                        : "",
                      attrs: { no: "33" },
                      model: {
                        value: _vm.form.packingName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "packingName", $$v)
                        },
                        expression: "form.packingName"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.insideQuantity,
                    attrs: { label: _vm.$t("SeaExport.Pieces2") }
                  },
                  [
                    _c("auto-number-input", {
                      class: _vm.importDifferenceField.insideQuantity
                        ? "red-border"
                        : "",
                      attrs: { no: "34", precision: 0, min: 0 },
                      model: {
                        value: _vm.form.insideQuantity,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "insideQuantity", $$v)
                        },
                        expression: "form.insideQuantity"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.insidePacking,
                    attrs: { label: _vm.$t("SeaExport.PiecesType2") }
                  },
                  [
                    _c("cargo-packing-select", {
                      class: _vm.importDifferenceField.insidePacking
                        ? "red-border"
                        : "",
                      attrs: {
                        no: "35",
                        "default-value": _vm.form.insidePacking
                      },
                      on: {
                        change: function(p) {
                          _vm.form.insidePacking = p.value
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.weight,
                    attrs: { label: _vm.$t("SeaExport.Weight") }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-item-input",
                        class: _vm.readonly
                          ? "input-disabled"
                          : _vm.importDifferenceField.weight
                          ? "red-border"
                          : ""
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "36",
                            precision: 3,
                            min: 0,
                            controls: false,
                            disabled: !_vm.isJydEditJobFields
                          },
                          on: {
                            change: function(p) {
                              _vm.CargoDocUtil.changeBillOfLadingSynJob(
                                _vm.job,
                                _vm.form,
                                true
                              )
                              _vm.pm.calculateChargeWeight()
                            }
                          },
                          model: {
                            value: _vm.form.weight,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "weight", $$v)
                            },
                            expression: "form.weight"
                          }
                        }),
                        _c("span", [_vm._v("KGS")])
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.cubage,
                    attrs: { label: _vm.$t("SeaExport.Cubage") }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-item-input",
                        class: _vm.readonly
                          ? "input-disabled"
                          : _vm.importDifferenceField.cubage
                          ? "red-border"
                          : ""
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "37",
                            precision: 3,
                            min: 0,
                            controls: false,
                            disabled: !_vm.isJydEditJobFields
                          },
                          on: {
                            change: function(p) {
                              _vm.CargoDocUtil.changeBillOfLadingSynJob(
                                _vm.job,
                                _vm.form,
                                true
                              )
                              _vm.pm.calculateChargeWeight()
                            }
                          },
                          model: {
                            value: _vm.form.cubage,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cubage", $$v)
                            },
                            expression: "form.cubage"
                          }
                        }),
                        _c("span", [_vm._v("CBM")])
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-item-input",
                        class: _vm.readonly
                          ? "input-disabled"
                          : _vm.importDifferenceField.chargeWeight
                          ? "red-border"
                          : ""
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "38",
                            precision: 3,
                            min: 0,
                            controls: false
                          },
                          on: {
                            change: function($event) {
                              return _vm.CargoDocUtil.changeBillOfLadingSynJob(
                                _vm.job,
                                _vm.form,
                                false
                              )
                            }
                          },
                          model: {
                            value: _vm.form.chargeWeight,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "chargeWeight", $$v)
                            },
                            expression: "form.chargeWeight"
                          }
                        }),
                        _c("span", [_vm._v("M/T")])
                      ],
                      1
                    )
                  ]
                ),
                _vm.isZh
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        class: _vm.variableCss.cargoEnglishName
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "flex-end"
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { no: "39", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.getHBLInfo("EName")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.CopyEnglishDescriptionOfGoodsFromHBL"
                                        )
                                      ) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.masterFlag,
                                        expression: "masterFlag"
                                      }
                                    ],
                                    staticStyle: { "margin-top": "5px" },
                                    attrs: { no: "40", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.getSlavesHBLEnglishName()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.CopyEnglishDescriptionOfGoodsFromReceipt"
                                        )
                                      ) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                !_vm.isZh
                  ? [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          class: _vm.variableCss.cargoEnglishName
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "41", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.getHBLInfo("EName")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.CopyEnglishDescriptionOfGoodsFromHBL"
                                  )
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.masterFlag,
                              expression: "masterFlag"
                            }
                          ],
                          staticClass: "auto-width",
                          class: _vm.variableCss.cargoEnglishName
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "42", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.getSlavesHBLEnglishName()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.CopyEnglishDescriptionOfGoodsFromReceipt"
                                  )
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    class: _vm.variableCss.cargoEnglishName,
                    attrs: {
                      label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                    }
                  },
                  [
                    _c(
                      "special-character-tip",
                      {
                        attrs: { texts: _vm.specialCharCheck.cargoEnglishName }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          ref: "cargoTextarea1",
                          class: _vm.importDifferenceField.cargoEnglishName
                            ? "red-border"
                            : "",
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "43",
                            "show-count": true,
                            "text-chars": _vm.englishNameMaxChars,
                            "warning-count": _vm.englishNameWarningCount,
                            "wrap-symbol": "r",
                            disabled: !_vm.isEdit,
                            "auto-uppercase": _vm.isUppercaseByConfig,
                            "auto-half-word": ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.cargoEnglishNameBlurHandler()
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                _vm.form.cargoEnglishName,
                                function(val) {
                                  _vm.form.cargoEnglishName = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.englishNameWarningCount,
                                  maxChar: _vm.englishNameMaxChars,
                                  autoUppercase: _vm.isUppercaseByConfig,
                                  autoHalfWord: true
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoEnglishName", $$v)
                            },
                            expression: "form.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.isZh
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        class: _vm.variableCss.mark
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "flex-end"
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { no: "44", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.getHBLInfo("mark")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.CopyMarksFromHbl")
                                      ) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.masterFlag,
                                        expression: "masterFlag"
                                      }
                                    ],
                                    staticStyle: { "margin-top": "5px" },
                                    attrs: { no: "45", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.getSlavesHBLMark()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.CopyMarksFromReceipt")
                                      ) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                !_vm.isZh
                  ? [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          class: _vm.variableCss.mark
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "46", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.getHBLInfo("mark")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.CopyMarksFromHbl")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          class: _vm.variableCss.mark
                        },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.masterFlag,
                                  expression: "masterFlag"
                                }
                              ],
                              attrs: { no: "47", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.pm.getSlavesHBLMark()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.CopyMarksFromReceipt")
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    class: _vm.variableCss.mark,
                    attrs: { label: _vm.$t("SeaExport.Marks") }
                  },
                  [
                    _c(
                      "special-character-tip",
                      { attrs: { texts: _vm.specialCharCheck.mark } },
                      [
                        _c("cargo-rich-textarea", {
                          ref: "cargoTextarea2",
                          class: _vm.importDifferenceField.mark
                            ? "red-border"
                            : "",
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "48",
                            "show-count": true,
                            "text-chars": _vm.markMaxChars,
                            "warning-count": _vm.markWarningCount,
                            "wrap-symbol": "r",
                            disabled: !_vm.isEdit,
                            "auto-uppercase": _vm.isUppercaseByConfig,
                            "auto-half-word": ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.markBlurHandler()
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Marks"),
                                _vm.form.mark,
                                function(val) {
                                  _vm.form.mark = val
                                },
                                false,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.markWarningCount,
                                  maxChar: _vm.markMaxChars,
                                  autoUppercase: _vm.isUppercaseByConfig,
                                  autoHalfWord: true
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.mark,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mark", $$v)
                            },
                            expression: "form.mark"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                  [
                    _c(
                      "special-character-tip",
                      { attrs: { texts: _vm.specialCharCheck.hsCode } },
                      [
                        _vm.syncMblHsCodeEdit
                          ? _c("el-input", {
                              class: _vm.importDifferenceField.hsCode
                                ? "red-border"
                                : "",
                              staticStyle: { width: "100%" },
                              attrs: { no: "49", type: "textarea", rows: 5 },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.HsCode"),
                                    _vm.form.hsCode,
                                    function(val) {
                                      _vm.form.hsCode = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form.hsCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "hsCode", $$v)
                                },
                                expression: "form.hsCode"
                              }
                            })
                          : _c("el-input", {
                              class: _vm.importDifferenceField.hsCode
                                ? "red-border"
                                : "",
                              staticStyle: { width: "100%" },
                              attrs: { no: "49", type: "textarea", rows: 5 },
                              on: {
                                input: function(val) {
                                  _vm.hsCodeChangeHandle(val)
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  _vm.showAdvanceTextDialog(
                                    _vm.$t("SeaExport.HsCode"),
                                    _vm.job.hsCode,
                                    function(val) {
                                      _vm.hsCodeChangeHandle(val)
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.job.hsCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "hsCode", $$v)
                                },
                                expression: "job.hsCode"
                              }
                            })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "auto-width",
                    attrs: {
                      label: _vm.$t("SeaExport.CapitalizedNumbersOfPackages")
                    }
                  },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.quantitySum
                        ? "red-border"
                        : "",
                      attrs: { disabled: true },
                      model: {
                        value: _vm.form.quantitySum,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "quantitySum", $$v)
                        },
                        expression: "form.quantitySum"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "CUS CODE" } },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.cusCode
                        ? "red-border"
                        : "",
                      attrs: { no: "cusCode" },
                      model: {
                        value: _vm.form.cusCode,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cusCode", $$v)
                        },
                        expression: "form.cusCode"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "NCM NO" } },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.ncmNo
                        ? "red-border"
                        : "",
                      attrs: { no: "ncmNo" },
                      model: {
                        value: _vm.form.ncmNo,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "ncmNo", $$v)
                        },
                        expression: "form.ncmNo"
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section form-column" },
          [
            _c(
              "el-form",
              {
                staticStyle: { height: "100%" },
                attrs: { "label-width": "100px", "label-position": "right" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.TransportInfo")))
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "MB/L NO." } },
                  [
                    _c("el-input", {
                      class: _vm.job.mbl === "CANCELLED" ? "mbl-red" : "",
                      attrs: { no: "50", disabled: _vm.readonly },
                      model: {
                        value: _vm.job.mbl,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "mbl", $$v)
                        },
                        expression: "job.mbl"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.soNoTitle,
                    attrs: { label: "SO NO." }
                  },
                  [
                    _c("so-no-input", {
                      class: _vm.variableCss.soNo,
                      attrs: { disabled: true },
                      model: {
                        value: _vm.job.soNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "soNo", $$v)
                        },
                        expression: "job.soNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "custom",
                    attrs: { label: _vm.$t("SeaExport.MBLBillOfLadingNum") }
                  },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.serialNo
                        ? "red-border"
                        : "",
                      attrs: { no: "51", disabled: _vm.readonly },
                      model: {
                        value: _vm.form.serialNo,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "serialNo", $$v)
                        },
                        expression: "form.serialNo"
                      }
                    })
                  ],
                  1
                ),
                _vm.isHZ
                  ? _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.VesselAndVoyage") } },
                      [
                        _c("el-input", {
                          class: _vm.importDifferenceField.vesselVoyage
                            ? "red-border"
                            : "",
                          attrs: { no: "82", disabled: _vm.readonly },
                          model: {
                            value: _vm.form.vesselVoyage,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "vesselVoyage", $$v)
                            },
                            expression: "form.vesselVoyage"
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "el-form-item",
                      {
                        class: _vm.variableCss.txtFirstVesselVoyageTitle,
                        attrs: { label: _vm.$t("SeaExport.VesselAndVoyage") }
                      },
                      [
                        _c("el-input", {
                          class: _vm.importDifferenceField.vesselVoyage
                            ? _vm.variableCss.txtFirstVesselVoyage +
                              " red-border"
                            : _vm.variableCss.txtFirstVesselVoyage,
                          attrs: {
                            disabled: true,
                            value: _vm.txtFirstVesselVoyage
                          }
                        })
                      ],
                      1
                    ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.DateOfDeparture") } },
                  [
                    _c("el-input", {
                      attrs: { value: _vm.sailingDate, disabled: true }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.dispatchingPlace,
                    attrs: { label: _vm.$t("SeaExport.PlaceOfReceiptOnBl") }
                  },
                  [
                    _c("cargo-advance-select", {
                      class: _vm.importDifferenceField.dispatchingPlaceCode
                        ? "red-border"
                        : "",
                      attrs: {
                        disabled: true,
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.form.dispatchingPlaceCode || "",
                        "tag-name": "englishName"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.pm.portChange(p, "dispatchingPlace")
                        }
                      }
                    }),
                    _c(
                      "special-character-tip",
                      {
                        attrs: { texts: _vm.specialCharCheck.dispatchingPlace }
                      },
                      [
                        _c("el-input", {
                          class: _vm.importDifferenceField.dispatchingPlace
                            ? "red-border"
                            : "",
                          attrs: {
                            "filter-chars": false,
                            no: "52",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dispatchingPlace", $$v)
                            },
                            expression: "form.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.loadingPort,
                    attrs: { label: _vm.$t("SeaExport.PortOfLoadingOnBl") }
                  },
                  [
                    _c("cargo-advance-select", {
                      class: _vm.importDifferenceField.loadingPortCode
                        ? "red-border"
                        : "",
                      attrs: {
                        disabled: true,
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.form.loadingPortCode || "",
                        "tag-name": "englishName",
                        no: "loadingPortCode"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.pm.portChange(p, "loadingPort")
                        }
                      }
                    }),
                    _c(
                      "special-character-tip",
                      { attrs: { texts: _vm.specialCharCheck.loadingPort } },
                      [
                        _c("el-input", {
                          class: _vm.importDifferenceField.loadingPort
                            ? "red-border"
                            : "",
                          attrs: {
                            "filter-chars": false,
                            no: "53",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.loadingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPort", $$v)
                            },
                            expression: "form.loadingPort"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.dischargingPort,
                    attrs: { label: _vm.$t("SeaExport.PortOfDischargeOnBl") }
                  },
                  [
                    _c("cargo-advance-select", {
                      class: _vm.importDifferenceField.dischargingPortCode
                        ? "red-border"
                        : "",
                      attrs: {
                        disabled: true,
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.form.dischargingPortCode || "",
                        "tag-name": "englishName",
                        no: "dischargingPortCode"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.pm.portChange(p, "dischargingPort")
                        }
                      }
                    }),
                    _c(
                      "special-character-tip",
                      {
                        attrs: { texts: _vm.specialCharCheck.dischargingPort }
                      },
                      [
                        _c("el-input", {
                          class: _vm.importDifferenceField.dischargingPort
                            ? "red-border"
                            : "",
                          attrs: {
                            "filter-chars": false,
                            no: "54",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.dischargingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargingPort", $$v)
                            },
                            expression: "form.dischargingPort"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.destinationPort,
                    attrs: { label: _vm.$t("SeaExport.PlaceOfDeliveryOnBl") }
                  },
                  [
                    _c("cargo-advance-select", {
                      class: _vm.importDifferenceField.destinationPortCode
                        ? "red-border"
                        : "",
                      attrs: {
                        disabled: true,
                        "select-type": _vm.selectTypeNames.basic_data_Seaport,
                        filterable: "",
                        "default-value": _vm.form.destinationPortCode || "",
                        "tag-name": "englishName",
                        no: "destinationPortCode"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.pm.portChange(p, "destinationPort")
                        }
                      }
                    }),
                    _c(
                      "special-character-tip",
                      {
                        attrs: { texts: _vm.specialCharCheck.destinationPort }
                      },
                      [
                        _c("el-input", {
                          class: _vm.importDifferenceField.destinationPort
                            ? "red-border"
                            : "",
                          attrs: {
                            "filter-chars": false,
                            no: "55",
                            disabled: _vm.readonly
                          },
                          model: {
                            value: _vm.form.destinationPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPort", $$v)
                            },
                            expression: "form.destinationPort"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.BlFinalDestination") } },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.destinationPlace
                        ? "red-border"
                        : "",
                      attrs: {
                        "filter-chars": false,
                        no: "56",
                        disabled: _vm.readonly
                      },
                      model: {
                        value: _vm.form.destinationPlace,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destinationPlace", $$v)
                        },
                        expression: "form.destinationPlace"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.MethodOfMblPayment") } },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.paymentTermMBL
                        ? "red-border"
                        : "",
                      attrs: {
                        disabled: true,
                        value: _vm.ColumnUtils.paymentTermLabelFunc(
                          _vm.job.paymentTermMBL
                        )
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.PlaceOfMblPayment2") } },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.paymentPlaceBL
                        ? "red-border"
                        : "",
                      attrs: { disabled: true, value: _vm.form.paymentPlaceBL }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SeaExport.TransportationClause") }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: true, value: _vm.job.freightTerm }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.BLNumber,
                    attrs: { label: _vm.$t("SeaExport.NoOfOriginalBls") }
                  },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.blNumber
                        ? "red-border"
                        : "",
                      attrs: { no: "57", disabled: _vm.readonly },
                      model: {
                        value: _vm.form.blNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "blNumber", $$v)
                        },
                        expression: "form.blNumber"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.NoOfCopyBls") } },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.blCopyNumber
                        ? "red-border"
                        : "",
                      attrs: { no: "58", disabled: _vm.readonly },
                      model: {
                        value: _vm.form.blCopyNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "blCopyNumber", $$v)
                        },
                        expression: "form.blCopyNumber"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.PlaceOfIssue") } },
                  [
                    _c("el-input", {
                      class: _vm.importDifferenceField.signPlaceBL
                        ? "red-border"
                        : "",
                      attrs: { no: "59", disabled: _vm.readonly },
                      model: {
                        value: _vm.form.signPlaceBL,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "signPlaceBL", $$v)
                        },
                        expression: "form.signPlaceBL"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.DateOfIssue") } },
                  [
                    _c("el-date-picker", {
                      class: _vm.importDifferenceField.signDateBL
                        ? "red-border"
                        : "",
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "60",
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.form.signDateBL,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "signDateBL", $$v)
                        },
                        expression: "form.signDateBL"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    class: _vm.variableCss.remarks,
                    attrs: { label: _vm.$t("SeaExport.BlRemarks") }
                  },
                  [
                    _c(
                      "special-character-tip",
                      { attrs: { texts: _vm.specialCharCheck.remarks } },
                      [
                        _c("cargo-input", {
                          class: _vm.importDifferenceField.remarks
                            ? _vm.variableCss.remarks + " red-border"
                            : _vm.variableCss.remarks,
                          attrs: {
                            disabled: _vm.readonly,
                            "use-read-only": true,
                            no: "61",
                            type: "textarea",
                            rows: 5,
                            "filter-chars": false
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.BlRemarks"),
                                _vm.form.remarks,
                                function(val) {
                                  _vm.form.remarks = val
                                },
                                false,
                                null,
                                false,
                                {
                                  warningCount: -1,
                                  maxChar: 0,
                                  autoUppercase: false,
                                  autoHalfWord: false
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.form.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section form-column" },
          [
            _c(
              "el-form",
              {
                staticStyle: { height: "100%" },
                attrs: {
                  disabled: _vm.readonly,
                  "label-width": "108px",
                  "label-position": "right"
                }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.OtherInfo")))
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.BlType") } },
                  [
                    _c(
                      "el-select",
                      {
                        class: _vm.importDifferenceField.releaseType
                          ? "red-border"
                          : "",
                        attrs: { no: "62" },
                        on: {
                          change: function(val) {
                            _vm.pm.cmbreleaseTypeMBLChangeHandler(val)
                          }
                        },
                        model: {
                          value: _vm.form.releaseType,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "releaseType", $$v)
                          },
                          expression: "form.releaseType"
                        }
                      },
                      _vm._l(_vm.blModeList, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.name, value: item.serialNumber }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.BlProperty") } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          no: "63",
                          value: _vm.job.typeMBL || 1,
                          disabled: _vm.cmbtypeMBLDisabled
                        },
                        on: {
                          input: function(val) {
                            _vm.pm.cmbtypeMBLChangeHandler(val)
                          }
                        }
                      },
                      _vm._l(_vm.BILL_TYPES, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.isZh
                              ? item.chineseName
                              : item.englishName,
                            value: item.code
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.job.jointMasterMBLUuid,
                        expression: "job.jointMasterMBLUuid"
                      }
                    ],
                    attrs: { label: _vm.$t("SeaExport.MBLHBR") }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        value: _vm.job.jointMasterMBL
                          ? _vm.job.jointMasterMBL.jobNo
                          : "",
                        disabled: true
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "red",
                    attrs: { label: _vm.$t("SeaExport.CheckingStatus") }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { "margin-bottom": "5px" },
                      attrs: { disabled: true, value: _vm.lblCfrState }
                    }),
                    _c(
                      "cargo-button-container",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_SingleRelease_singleRelease"],
                            expression: "['button_SingleRelease_singleRelease']"
                          }
                        ],
                        staticStyle: { float: "right", "margin-left": "5px" },
                        attrs: {
                          no: "64",
                          disabled:
                            _vm.btnReleasingDisabled || !_vm.cooperateEdit
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.btnReleasingClickHandler()
                          }
                        }
                      },
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.cfmState === 10
                                ? _vm.$t("SeaExport.CancelReleasing")
                                : _vm.$t("SeaExport.Releasing")
                            ) + " "
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "cargo-button-container",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_SingleRelease_getBack"],
                            expression: "['button_SingleRelease_getBack']"
                          }
                        ],
                        staticStyle: { float: "right" },
                        attrs: {
                          no: "65",
                          disabled: _vm.btnGetBackDisabled || !_vm.cooperateEdit
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.btnGetBackClickHandler()
                          }
                        }
                      },
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.bliStatus === 7
                                ? _vm.$t("SeaExport.CancelGetBack")
                                : _vm.$t("SeaExport.Back")
                            ) + " "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "red",
                    attrs: { label: _vm.$t("SeaExport.BillLadingIssued") }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.billLadingIssued,
                        callback: function($$v) {
                          _vm.billLadingIssued = $$v
                        },
                        expression: "billLadingIssued"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "red",
                    attrs: { label: _vm.$t("SeaExport.ReleasingStatus") }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: true, value: _vm.lblReleaseState }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "red",
                    attrs: { label: _vm.$t("SeaExport.RequestReleaseState") }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        value:
                          _vm.form.requestReleaseState === 0
                            ? _vm.$t("SeaExport.NotApplying")
                            : _vm.$t("SeaExport.Requested"),
                        disabled: true
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticStyle: { float: "left", "margin-left": "-85px" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.job.jointMasterMBLUuid
                              ? _vm.$t("SeaExport.TicketHasMerged")
                              : _vm.job.typeMBL ===
                                _vm.BillType.SPLIT_BILL_TYPE.code
                              ? _vm.$t("SeaExport.TicketHasSplit")
                              : ""
                          )
                        )
                      ]
                    ),
                    _c(
                      "cargo-button-container",
                      {
                        staticStyle: { float: "right", "margin-left": "5px" },
                        attrs: {
                          no: "requestReleaseState",
                          disabled:
                            _vm.btnBLConfirmDisabled || !_vm.cooperateEdit
                        },
                        on: {
                          click: function($event) {
                            return _vm.pm.btnRequestReleasingClickHandler()
                          }
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_M/HBL_SingleReleaseMBL"],
                                expression: "['button_M/HBL_SingleReleaseMBL']"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.job.jointMasterMBLUuid ||
                                _vm.job.typeMBL ===
                                  _vm.BillType.SPLIT_BILL_TYPE.code,
                              type: "primary"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.form.requestReleaseState === 0
                                    ? _vm.$t("SeaExport.ApplyForARelease")
                                    : _vm.$t(
                                        "SeaExport.WithdrawTheRequestForRelease"
                                      )
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "red",
                    attrs: { label: _vm.$t("SeaExport.ReleaseEligibleStatus") }
                  },
                  [
                    _c("el-input", {
                      attrs: { value: _vm.releaseEligibleLabel, disabled: true }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.preverifyDate") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: true,
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.form.reviewDate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "reviewDate", $$v)
                        },
                        expression: "form.reviewDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SeaExport.DateOfCargoDetention") }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: true,
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.form.withholdDate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "withholdDate", $$v)
                        },
                        expression: "form.withholdDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.BlReleasingNo") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: true, value: _vm.form.surrenderedNo }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.ReleasingDate") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: true,
                        type: "date",
                        "value-format": "yyyy-MM-dd"
                      },
                      model: {
                        value: _vm.form.releaseDate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "releaseDate", $$v)
                        },
                        expression: "form.releaseDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.ParamRemark") } },
                  [
                    _c(
                      "el-select",
                      {
                        class: _vm.importDifferenceField.printParam4
                          ? "red-border"
                          : "",
                        attrs: {
                          no: "66",
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("CargoMsg.Cargo_PleaseSelect")
                        },
                        model: {
                          value: _vm.form.printParam4,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "printParam4", $$v)
                          },
                          expression: "form.printParam4"
                        }
                      },
                      _vm._l(_vm.pm.printParam4Type, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.label, value: item.data }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.ShippingCompanySCAC") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: true, value: _vm.txtCarrierScAc }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.OverseasAgentSCAC") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: true, value: _vm.txtBookingAgentScAc }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.ManifestDescriptionOfGoods")
                    }
                  },
                  [
                    _c("cargo-rich-textarea", {
                      class: _vm.importDifferenceField.cargoManifestName
                        ? "red-border"
                        : "",
                      staticStyle: { height: "110px" },
                      attrs: {
                        no: "67",
                        disabled: _vm.readonly,
                        "text-chars": 0,
                        "warning-count": -1,
                        "wrap-symbol": "r"
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.ManifestDescriptionOfGoods"),
                            _vm.form.cargoManifestName,
                            function(val) {
                              _vm.form.cargoManifestName = val
                            },
                            false,
                            null,
                            true,
                            {
                              warningCount: -1,
                              maxChar: 0,
                              autoUppercase: false,
                              autoHalfWord: false
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.form.cargoManifestName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "cargoManifestName", $$v)
                        },
                        expression: "form.cargoManifestName"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SeaExport.ReasonOfCargoDetention") }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        disabled: true,
                        value: _vm.form.withholdReason,
                        type: "textarea",
                        rows: 5
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_OrderModificationTimes")
                    }
                  },
                  [
                    _c("auto-number-input", {
                      attrs: { precision: 0, min: 0, no: "modificationCount" },
                      model: {
                        value: _vm.form.modificationCount,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "modificationCount", $$v)
                        },
                        expression: "form.modificationCount"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("CargoMsg.Cargo_PortRequirement") }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        no: "portRequirement",
                        type: "textarea",
                        rows: 5
                      },
                      model: {
                        value: _vm.form.portRequirement,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "portRequirement", $$v)
                        },
                        expression: "form.portRequirement"
                      }
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "line-height": "16px",
                          "margin-top": "5px",
                          cursor: "pointer"
                        },
                        on: {
                          click: function($event) {
                            return _vm.downloadAttachment(
                              _vm.form.regionWarehouseMappingUuid
                            )
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-paperclip",
                          staticStyle: { "font-size": "16px" }
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "text-decoration": "underline",
                              color: "blue"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SystemMaintenance.PortRequirementsRelatedDocuments"
                                )
                              )
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner edi-bill-search-selector",
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: _vm.advanceTextDialog.showContact ? "900px" : "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              disabled: !_vm.isEdit
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "50px", "label-position": "left" } },
                [
                  _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.advanceTextDialog.showContact,
                          expression: "advanceTextDialog.showContact"
                        }
                      ],
                      staticStyle: { "padding-top": "20px" },
                      attrs: { gutter: 10 }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ContactPerson")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.readonly },
                                model: {
                                  value:
                                    _vm.advanceTextDialog.extendData.contact,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.advanceTextDialog.extendData,
                                      "contact",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "advanceTextDialog.extendData.contact"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Tel") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  autocomplete: _vm.$t("SeaExport.Tel"),
                                  disabled: _vm.readonly
                                },
                                model: {
                                  value:
                                    _vm.advanceTextDialog.extendData.mobile,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.advanceTextDialog.extendData,
                                      "mobile",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "advanceTextDialog.extendData.mobile"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Fax") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.readonly },
                                model: {
                                  value: _vm.advanceTextDialog.extendData.fax,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.advanceTextDialog.extendData,
                                      "fax",
                                      $$v
                                    )
                                  },
                                  expression: "advanceTextDialog.extendData.fax"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.advanceTextDialog.showContact,
                          expression: "advanceTextDialog.showContact"
                        }
                      ],
                      attrs: { gutter: 10 }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Email2") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  autocomplete: _vm.$t("SeaExport.Email2"),
                                  disabled: _vm.readonly
                                },
                                model: {
                                  value: _vm.advanceTextDialog.extendData.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.advanceTextDialog.extendData,
                                      "email",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "advanceTextDialog.extendData.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.ZIP") } },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.readonly },
                                model: {
                                  value:
                                    _vm.advanceTextDialog.extendData.zipCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.advanceTextDialog.extendData,
                                      "zipCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "advanceTextDialog.extendData.zipCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.City") } },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  disabled: _vm.readonly,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value":
                                    _vm.advanceTextDialog.extendData.city,
                                  "options-width": "110px"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.advanceTextDialog.extendData.city =
                                      p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")) + " ")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          params: _vm.billAddressDialog.params,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("job-no-transcribe-dialog", {
        attrs: {
          visible: _vm.searchBillNoDialog.visible,
          params: _vm.searchBillNoDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.pm.selectionItemHandler(p)
          }
        }
      }),
      _vm.emailInput.visible
        ? _c("email-input", {
            attrs: {
              visible: _vm.emailInput.visible,
              context: _vm.context,
              job: _vm.job,
              source: "tabMBL",
              "push-link": _vm.SystemConstants.MBL_INVITATION_STATEMENT,
              "is-copy-link": true,
              "job-eamil-data": _vm.jobEamilData,
              "send-email-data": _vm.emailInput,
              "send-call-back": _vm.onEmailExecute
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.emailInput, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("match-history-dialog", {
        attrs: {
          visible: _vm.matchHistoryDialog.visible,
          "cargo-doc-uuid": _vm.form.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.matchHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("receipt-history-dialog", {
        attrs: {
          visible: _vm.receiptHistoryDialog.visible,
          "job-uuid": _vm.job.uuid || ""
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.receiptHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("status-change-history-dialog", {
        attrs: {
          visible: _vm.statusChangeHistoryDialog.visible,
          "business-data-id": _vm.form.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.statusChangeHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("dialog-selector", {
        attrs: {
          visible: _vm.selectorDialog.visible,
          title: _vm.selectorDialog.title,
          "row-data": _vm.selectorDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectorDialog, "visible", $event)
          },
          selected: _vm.getEDICallback
        }
      }),
      _c("message-preview-dialog", {
        attrs: {
          visible: _vm.messagePreviewDialog.visible,
          params: _vm.messagePreviewDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.messagePreviewDialog, "visible", $event)
          },
          uploadSuccess: function($event) {
            {
            }
          }
        }
      }),
      _vm.ediDocWindow.visible
        ? _c("edi-doc-window", {
            ref: "ediDocWindow",
            attrs: {
              visible: _vm.ediDocWindow.visible,
              "global-var": _vm.globalVar,
              "edi-status-name": _vm.ediStatusName,
              "call-back-func": _vm.ediDocWindow.callBackFunc,
              context: _vm.context
            },
            on: {
              close: function($event) {
                _vm.ediDocWindow.visible = false
              }
            }
          })
        : _vm._e(),
      _c("multi-seg-num-rules-dialog", {
        attrs: { visible: _vm.multiSegNumRulesDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.multiSegNumRulesDialog, "visible", $event)
          },
          callback: _vm.multiSegNumRulesCallback
        }
      }),
      _c("api-popup", {
        attrs: {
          visible: _vm.apiPopup.visible,
          title: _vm.apiPopup.title,
          "interface-type": _vm.apiPopup.interfaceType,
          "interface-array": _vm.apiPopup.interfaceArray
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.apiPopup, "visible", $event)
          },
          selectedApi: _vm.selectedApiCallback
        }
      }),
      _c("error-log-dialog", {
        attrs: {
          visible: _vm.errorLogDialog.visible,
          "error-log": _vm.errorLogDialog.errorLog
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.errorLogDialog, "visible", $event)
          }
        }
      }),
      _c("cargo-doc-extend", {
        attrs: {
          visible: _vm.cargoDocExtendDialog.visible,
          title: _vm.cargoDocExtendDialog.title,
          "job-uuid": _vm.job.uuid,
          "sea-cargo-doc": _vm.form,
          "carrier-id": _vm.job.carrierId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cargoDocExtendDialog, "visible", $event)
          }
        }
      }),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.job.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("sync-container-info-dialog", {
        ref: "syncContainerInfoDialog",
        attrs: {
          visible: _vm.syncContainerInfoDialog.visible,
          "change-post-func": _vm.syncContainerInfoChangeHandle
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.syncContainerInfoDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }